export default "__VITE_ASSET__BVqkgOy8__ 640w, __VITE_ASSET__CaldFaWU__ 1024w, __VITE_ASSET__j42yAiCJ__ 1536w";